import React from 'react';

// Skeleton component for individual topic cards
const TopicCardSkeleton = () => (
  <div className="topic-card mb-4" style={{
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    border: "1px solid #e0e0e0",
    overflow: "hidden",
  }}>
    <div className="topic-header d-flex align-items-center justify-content-between p-4" style={{
      backgroundColor: "#f8f9fa",
      borderBottom: "1px solid #e0e0e0",
    }}>
      <div className="d-flex align-items-center flex-grow-1">
        <div style={{
          width: "24px",
          height: "24px",
          backgroundColor: "#e0e0e0",
          borderRadius: "4px",
          marginRight: "12px",
        }} className="skeleton-pulse" />
        <div>
          <div style={{
            width: "180px",
            height: "20px",
            backgroundColor: "#e0e0e0",
            borderRadius: "4px",
            marginBottom: "8px",
          }} className="skeleton-pulse" />
          <div style={{
            width: "250px",
            height: "14px",
            backgroundColor: "#e0e0e0",
            borderRadius: "4px",
          }} className="skeleton-pulse" />
        </div>
      </div>
      <div className="d-flex align-items-center">
        <div style={{
          width: "60px",
          height: "24px",
          backgroundColor: "#e0e0e0",
          borderRadius: "12px",
          marginRight: "12px",
        }} className="skeleton-pulse" />
        <div style={{
          width: "18px",
          height: "18px",
          backgroundColor: "#e0e0e0",
          borderRadius: "4px",
        }} className="skeleton-pulse" />
      </div>
    </div>
  </div>
);

// Skeleton component for the header section with updated gradient
const HeaderSkeleton = () => (
  <div className="classroom-header mb-4" style={{
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    color: "white",
  }}>
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div>
        <div style={{
          width: "200px",
          height: "32px",
          backgroundColor: "rgba(255,255,255,0.3)",
          borderRadius: "4px",
          marginBottom: "12px",
        }} className="skeleton-pulse" />
        <div style={{
          width: "300px",
          height: "16px",
          backgroundColor: "rgba(255,255,255,0.3)",
          borderRadius: "4px",
        }} className="skeleton-pulse" />
      </div>
      <div style={{
        width: "140px",
        height: "44px",
        backgroundColor: "rgb(25, 118, 210)",
        borderRadius: "24px",
        border: "none",
      }} className="skeleton-pulse" />
    </div>

    {/* Statistics skeleton */}
    <div className="row">
      {[1, 2].map((index) => (
        <div key={index} className="col-md-4">
          <div className="stat-card text-center p-3" style={{
            backgroundColor: "rgba(255,255,255,0.2)",
            borderRadius: "8px",
            border: "1px solid rgba(255,255,255,0.1)",
          }}>
            <div style={{
              width: "40px",
              height: "32px",
              backgroundColor: "rgba(255,255,255,0.3)",
              borderRadius: "4px",
              margin: "0 auto 8px",
            }} className="skeleton-pulse" />
            <div style={{
              width: "80px",
              height: "14px",
              backgroundColor: "rgba(255,255,255,0.3)",
              borderRadius: "4px",
              margin: "0 auto",
            }} className="skeleton-pulse" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

// Main skeleton component
const CourseMaterialsSkeleton = () => {
  return (
    <div style={{
      overflow: "auto",
      height: "90vh",
      backgroundColor: "#f8f9fa",
    }}>
      <div style={{ padding: "16px" }}>
        {/* Header Skeleton with new gradient */}
        <HeaderSkeleton />

        {/* Topic Cards Skeleton */}
        <div className="topics-container">
          {[1, 2, 3].map((index) => (
            <TopicCardSkeleton key={index} />
          ))}
        </div>
      </div>

      {/* Skeleton CSS animations */}
      <style jsx>{`
        @keyframes skeleton-pulse {
          0% {
            opacity: 1;
          }
          50% {
            opacity: 0.6;
          }
          100% {
            opacity: 1;
          }
        }

        .skeleton-pulse {
          animation: skeleton-pulse 1.5s ease-in-out infinite;
        }

        .skeleton-shimmer {
          background: linear-gradient(90deg, 
            transparent 0%, 
            rgba(255,255,255,0.4) 50%, 
            transparent 100%
          );
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
        }

        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
      `}</style>
    </div>
  );
};

export default CourseMaterialsSkeleton;